import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { inject } from 'mobx-react';
import { SelectorGrid } from './selector-grid';
import { songColumns, songDefaultSortInfo } from '../grid-data/artist-grid-data';
import { Text } from 'common/components/field-factory/fields';

import songsStore from 'client/shared/stores/songs-store';
import artistStore from 'client/shared/stores/artist-store';
import albumsStore from 'client/shared/stores/artist-store';

import ItemCarousel from 'common/components/item-carousel';

const EditList = ({editItem, playlistStore, onSaveList, onDelete, onCancel, listType: initialListType = "SONG", listLabel: initialListLabel = "Song", listMode: initialListMode = "CREATE"}) => {
    const { register } = useForm();
    const [listType, setListType] = useState(initialListType);
    const [listLabel, setListLabel] = useState(initialListLabel);
    const [listMode, setListMode] = useState(initialListMode);
    const [songItems, setSongItems] = useState([]);
    const [artistItems, setArtistItems] = useState([]);
    const [albumItems, setAlbumItems] = useState([]);
    const [selectedItemIDs, setSelectedItemIDs] = useState(editItem.itemIDs ? editItem.itemIDs : []);
    const [loading, setLoading] = useState(true);
    const [listTitle, setListTitle] = useState(editItem ? editItem.title : '');

    useEffect(() => {
        setListType(initialListType);
    }, [initialListType]);
    
    useEffect(() => {
        setListLabel(initialListLabel);
    }, [initialListLabel]);

    useEffect(() => {
        setListMode(initialListMode);
    }, [initialListMode]);

    useEffect(() => {
        const fetchData = async () => {
            await songsStore.fetchIfEmpty();
            await artistStore.fetchIfEmpty();
            await albumsStore.fetchIfEmpty();
            setSongItems(songsStore.items);
            console.log("SONG ITEMS: ", songsStore.items);
            setArtistItems(artistStore.items);
            setAlbumItems(albumsStore.items);
            setLoading(false);
        }
        fetchData();
    }, [])

    const targetList = useMemo(() => {
        switch (listType) {
            case 'SONG':
            case 'SONGS':
                return songItems;
            case 'ARTIST':
            case 'FEATURED':
                return artistItems;
            case 'ALBUM':
            case 'ALBUMS':
                return albumItems;
            default:
                return songItems;
        }
    }, [listType, songItems, artistItems, albumItems]);

    const [ListMeta, SetListMeta] = useState({sortInfo: songDefaultSortInfo, colSource: songColumns})

    const toggleIncludeItem = (item) => {
        if (selectedItemIDs.includes(item.id)) {
            setSelectedItemIDs(selectedItemIDs.filter(id => id !== item.id));
        } else {
            setSelectedItemIDs([...selectedItemIDs, item.id]);
        }
    }

    

    return (
        <div>
            <div className="grid-x grid-padding-x">
                {
                    listMode === "CREATE" ? (
                        <h4>Create New {listLabel} List</h4>
                    ) : (
                        <h4>Edit {listLabel} List</h4>
                    )
                }
                <button className="margin-left-2 button neo" onClick={() => onSaveList(listTitle, listType, selectedItemIDs)}>Save</button>
                <button className="margin-left-1 button neo" onClick={onCancel}>Cancel</button>
                <button className="margin-left-1 button alert" onClick={onDelete}>Delete</button>
            </div>
          
            <div className="grid-x grid-padding-x">
                <div className='selection-area cell small-6 padding-4'>
                    {loading && <p>Loading...</p>}
                    {!loading && 
                        <SelectorGrid dataSource={targetList} gridType={listType} selectedItems={selectedItemIDs} onSelectItem={toggleIncludeItem}/>
                    }
                </div>
                <div className='selection-area cell small-6 padding-left-2'>
                    <h6 style={{textTransform:'uppercase'}}>List Details:</h6>
                    <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                        <Text
                            label="List Name"
                            fieldKey="listTitle"
                            inputClass="admin-field"
                            defaultValue={listTitle}
                            onChange={(e) => setListTitle(e.target.value)}
                            register={register}
                        />
                        {/* <Text
                            label="List Description"
                            fieldKey="listMetadata.listDescription"
                            inputClass="admin-field"
                            defaultValue={listMetadata.listDescription}
                            register={register}
                        /> */}
                    </div>
                </div>
            </div>
            <div>
                <h6 style={{textTransform:'uppercase'}}>List Preview:</h6>
                <ItemCarousel
                    sectionLabel={ listTitle || "Untitled List" }
                    listType={ listType }
                    items={ selectedItemIDs.map(id => targetList.find(item => item.id === id)).filter(item => item) } 
                />
            </div>
            
        </div>
    )
}

export default EditList;